export interface OptionPresetItemDto {
    id: number;
    optionPresetId: number;
    optionGroupId: number;
    optionItemId: number;
    projectCatalogProductId: number;
    isDefault: boolean;
}

export enum PresetItemUpdateType {
    Linked = 'Linked',
    Default = 'Default',
    Unlinked = 'Unlinked',
}
export interface PresetItemUpdateDto {
    optionItemId: number;
    updateType: PresetItemUpdateType;
}
